export default __webpack_public_path__ + "static/media/tmhl.dee6bf37.jpg";